import { AccessTokenScope } from '@common/interfaces/accessToken'
import Base from './base'

export interface ICreateAccessTokenData {
  name: string
  scopes: AccessTokenScope[]
  expiresAt?: string
}

export interface IUpdateAccessTokenData {
  name: string
  scopes: AccessTokenScope[]
}

export default class AccessTokens extends Base {
  list() {
    return this.apiClient.get('users/me/access-tokens')
  }

  create(data: ICreateAccessTokenData) {
    return this.apiClient.post('users/me/access-tokens', data)
  }

  update(id: string, data: IUpdateAccessTokenData) {
    return this.apiClient.put(`users/me/access-tokens/${id}`, data)
  }

  revoke(id: string) {
    return this.apiClient.put(`users/me/access-tokens/${id}/revoke`)
  }
}
